import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';

@Injectable({
  providedIn: 'root'
})
export class FeaturesService extends FgiBackEndService<any> {

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/features';
  }

  getFeaturesAmbiente(): Observable<any> {
    return this.http.get(`${this.BASE_URL}`) as Observable<any>;
  }
}
